// ── Whether rich text holds anything a reader would see: keep in sync with
//    progsity-backend/src/shared/validation/html-content.ts
//    progsity-admin/src/lib/html-content.ts
//
// An editor the author cleared still sends markup: `<p></p>`, or a paragraph
// holding only a non-breaking space. Stored as a value, that read as content
// everywhere a field is checked for truthiness: a Bangla reader got a blank
// statement instead of the English fallback, and an empty Notes section
// printed its heading. A picture, a video, a formula or a diagram is content
// even with no text around it.
// ─────────────────────────────────────────────────────────────────────────

const CONTENT_ELEMENT = /<(img|iframe|video|svg)\b|\bdata-(latex|source|video-[a-z-]+)=/i;

export function hasHtmlContent(html: string | null | undefined): html is string {
  if (!html) return false;
  if (CONTENT_ELEMENT.test(html)) return true;
  const text = html
    .replace(/<[^>]*>/g, "")
    .replace(/&nbsp;|&#160;|&#xa0;|\u00a0/gi, "")
    .trim();
  return text.length > 0;
}
